import { DefaultFetchService } from "app/services/fetchService";
import categoryService from "app/common/services/categoryService";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import type { DurationService as durationServices } from "app/services/DurationService";
import DurationService from "app/services/DurationService";
import { PdfExportService } from "app/services/PdfExportService";
import { useMemo } from "react";
import type { Translate } from "app/filters/i18nFilter";
import { i18nFilter } from "app/filters/i18nFilter";
import type { ICountryService } from "app/services/CountryService";
import CountryService from "app/services/CountryService";
import type { NavigatorType } from "single-spa/react-app/ProNavigator";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export interface IServices {
    translate: Translate;
    fetchService: DefaultFetchService;
    navigator: NavigatorType;
    categoryService: typeof categoryService;
    customCategoryService: typeof UserCustomCategoryService;
    durationService: durationServices;
    pdfService: typeof PdfExportService;
    countryService: ICountryService;
}

export const useMarketingChannelsServices = () => {
    const services = useMemo<IServices>(() => {
        return {
            translate: i18nFilter(),
            fetchService: DefaultFetchService.getInstance(),
            navigator: proNavigator,
            durationService: DurationService,
            categoryService: categoryService,
            customCategoryService: UserCustomCategoryService,
            pdfService: PdfExportService,
            countryService: CountryService,
        };
    }, []);

    return { services };
};
